import { DEPARTMENTS, type ProductCategory } from './departments';

export interface ShoppingTextItem {
  name: string;
  unit: string;
  amount: number | null;
  category: ProductCategory;
}

const APP_URL = 'https://t.me/recipt_help_Bot/app';

function line(it: ShoppingTextItem): string {
  const qty = it.amount === null || it.amount === 0 ? 'по вкусу' : `${it.amount} ${it.unit}`;
  return `• ${it.name} — ${qty}`;
}

// items — недостающее (то, что в блоке «Не хватает»); extras — «по вкусу/без количества».
// Пустой ввод → '' (вызывающий не показывает кнопку отправки).
export function buildShoppingText(items: ShoppingTextItem[], extras: Array<{ name: string }>): string {
  if (items.length === 0 && extras.length === 0) return '';
  const blocks: string[] = ['🛒 Список покупок — Рецепт.ИИ'];

  for (const dep of DEPARTMENTS) {
    const group = items
      .filter((i) => i.category === dep.key)
      .sort((a, b) => a.name.localeCompare(b.name, 'ru'));
    if (group.length) blocks.push(`\n${dep.label}:\n${group.map(line).join('\n')}`);
  }

  if (extras.length) {
    const ex = [...extras].sort((a, b) => a.name.localeCompare(b.name, 'ru'));
    blocks.push(`\nПо вкусу / без количества:\n${ex.map((e) => `• ${e.name}`).join('\n')}`);
  }

  blocks.push(`\nСобрано в Рецепт.ИИ: ${APP_URL}`);
  return blocks.join('\n');
}
